import styled from 'styled-components';

export const LinkStyleSettingsReceipts = styled.a`
  text-decoration: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 300;
  color: ${props => props.theme.colors.primary['blue-2']};

  &:hover {
    color: ${props =>
      props.color ? props.color : props.theme.colors.primary['blue-1']};
  }
`;

export const LinkStyleUserSubHeader = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const LinkStyleMetadata = styled.a<{ bold?: boolean }>`
  color: ${props =>
    props.color ? props.color : props.theme.colors.primary['blue-2']};
  font-weight: ${props => (props.bold ? '600' : 'normal')};
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
  text-transform: capitalize;

  &:hover {
    color: ${props =>
      props.color ? props.color : props.theme.colors.primary['blue-1']};
  }
`;
